import React from 'react';
import BaseFactory from './BaseFactory';
import CustomDescriptionSection from './CustomDescriptionSection';

class Traditional extends BaseFactory {
  getDescription() {
    return (
      `Book an appointment at ${this.clinicName}, located at ${this.address}` +
      `in ${this.city}, ${this.state}. ${this.ratingCount} reviews of ${this.clinicName}.`
    );
  }

  getKeywords() {
    return (
      `${this.clinicName}, ${this.clinicName}, ${this.city}, ${this.clinicName} ${this.zip},` +
      `doctor ${this.city}, doctor's visit ${this.zip}, doctor's appointment ${this.city},`
    );
  }

  getBody() {
    return (
      <span>
        <CustomDescriptionSection location={this.location} />
      </span>
    );
  }
}

export default Traditional;
